/**
 * File cookies.js.
 *
 * Handles cookie-related logic, including getting and setting cookies.
 *
 */

/**
 * Sets a cookie with a given value.
 *
 * @param {string} cname  The name of the cookie.
 * @param {any}    cvalue The value of the cookie.
 * @param {number} exdays Number of days before the cookie expires. Defaults to 1.
 */
function setCookie(cname, cvalue, exdays = 1) {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/**
 * Gets a cookie's value .
 *
 * @param {string} cname The name of the cookie.
 */
function getCookie(cname) {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return false;
}

function removeCookie(cookieName) {
	document.cookie =
		cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export { setCookie, getCookie, removeCookie };
